import { createFileRoute } from '@tanstack/react-router';

import { IssuePage } from '../../pages/issues';
import { useSession } from '../../entities/session';

export const Route = createFileRoute('/_shell/issues/$issueId')({
  component: function IssueRoute() {
    const { issueId } = Route.useParams();
    const session = useSession();

    return (
      <IssuePage
        issueId={issueId}
        timeZone={session.data?.preferences.timezone}
        viewer={session.data && { id: session.data.user.id, name: session.data.user.name }}
      />
    );
  },
});
